import React, { useEffect, useState } from "react";
import "./SelectedImages.css";

const SelectedImages = ({
  selectedImages,
  selectImage,
  type,
  covertBytesToKBMBGB,
}) => {
  const [ScrollNeed, setScrollNeed] = useState(false);
  const [CurrentIndex, setCurrentIndex] = useState([0, 1, 2]);
  useEffect(() => {
    console.log("Current index ", CurrentIndex);
  }, [CurrentIndex]);
  useEffect(() => {
    if (selectedImages.length > 3) {
      setScrollNeed(true);
    }
  }, [selectedImages]);
  const isLastIndex = (index) => {
    return index === selectedImages.length - 1;
  };

  const isFirstIndex = (index) => {
    return index === 0;
  };
  const prevPage = () => {
    if (isFirstIndex(CurrentIndex[0])) {
      return;
    }
    let newIndex = [];
    for (let i = 3; i >= 1; i--) {
      newIndex.push(CurrentIndex[0] - i);
    }
    setCurrentIndex(newIndex);
  };
  const nextPage = () => {
    if (isLastIndex(CurrentIndex[CurrentIndex.length - 1])) {
      return;
    }
    let newIndex = [];
    for (
      let i = CurrentIndex[0];
      i <= CurrentIndex[CurrentIndex.length - 1] &&
      i + 3 < selectedImages.length;
      i++
    ) {
      newIndex.push(i + 3);
    }
    setCurrentIndex(newIndex);
  };

  if (type === "image")
    return (
      <div className="selected-images__main">
        {ScrollNeed && (
          <div
            className={` ${
              CurrentIndex[0] == 0 ? "selected-images__scroll_disable" : ""
            } selected-images__scroll `}
            onClick={prevPage}
          >
            {" "}
            &lt;{" "}
          </div>
        )}
        {/* <div className="selected-images_submain">
          {selectedImages.map((image, index) => {
            if (CurrentIndex.includes(index)) {
              return (
                <img
                  key={index}
                  src={image}
                  className="selected-images__img"
                  alt={`Image ${index + 1}`}
                  onClick={() => {
                    selectImage(index);
                  }}
                />
              );
            }
          })}
        </div> */}
        {ScrollNeed && (
          <div
            className={`${
              CurrentIndex[2] == selectedImages.length - 1
                ? "selected-images__scroll_disable"
                : ""
            } selected-images__scroll`}
            onClick={nextPage}
          >
            {" "}
            &gt;{" "}
          </div>
        )}
      </div>
    );
  else if (type === "document") {
    return (
      <div className="selected-images__main selected-docs__main">
        {ScrollNeed && (
          <div
            className={` ${
              CurrentIndex[0] == 0 ? "selected-images__scroll_disable" : ""
            } selected-images__scroll `}
            onClick={prevPage}
          >
            {" "}
            &lt;{" "}
          </div>
        )}
        {/* {selectedImages.map((data, index) => {
          if (CurrentIndex.includes(index)) {
            return (
              <div
                className=" selected-images_img  selected-images__document"
                key={index}
                onClick={() => selectImage(index)}
              >
                <span className="selected-images_doc_name">{data.name}</span>{" "}
                <span className="seleceted-images_doc_size">
                  {covertBytesToKBMBGB(data.size)}
                </span>
              </div>
            );
          }
        })} */}
        {ScrollNeed && (
          <div
            className={`${
              CurrentIndex[CurrentIndex.length - 1] ===
              selectedImages.length - 1
                ? "selected-images__scroll_disable"
                : ""
            } selected-images__scroll`}
            onClick={nextPage}
          >
            {" "}
            &gt;{" "}
          </div>
        )}
      </div>
    );
  }
};

export default SelectedImages;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/ImageLibrary/SelectedImages.js